<template>
  <div class="app" ref="body" @scroll="scrollTop()">
    <search :isBack='true' :isNum="0"></search>
    <banner :list="list" :Dtype="'heng'"></banner>

    <classification :iSsource="iSsource" @kong="kong" @isClassifyAction="isClassifyAction"></classification>
    <div ref="gun"><commodity :list="listT"></commodity></div>

    <bottom></bottom>
    <hotline></hotline>
  </div>
</template>

<script>
import search from '../../components/gyl/search'
import Banner from '../../components/Banner'

import classification from './components/classification'
import commodity from '../../components/gyl/commodity'

import hotline from '../../components/hotline'
import bottom from '../../components/gyl/bottom'

export default {
  name: 'gyl',
  components: {
    search,
    Banner,

    classification,
    commodity,

    hotline,
    bottom
  },
  data () {
    return {
      list: [{
        banner_img: require('../../assets/img/gyl/indexCB.png')
      }],
      iSsource: 1,
      listT: [],
      page: 1,
      limit: 30,
      laoding: true,
      isFixed: false,
      scroll: true,
      MaBottom1: true,
      MaBottom: '下拉加载更多',
    }
  },
  mounted () {
    this.postList()
  },
  methods: {
    scrollTop () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isFixed = scrollTop - 400 > this.offsetTop
      let scrollTopS = this.$refs.body.scrollTop// 滚动条的高
      if (this.scroll) {
        let documentTop = this.$refs.gun.scrollHeight// 全部内容的高
        let screenHeight = this.$refs.body.clientHeight// 当前屏幕的高
        if (scrollTopS + screenHeight >= documentTop) {
          this.page++
          this.postList()
        }
      }
    },
    kong (i) {
      this.$toast('暂无权限')
    },
    isClassifyAction (i) {
      this.iSsource = i
      this.page = 1
      this.postList()
    },
    postList () {
      let that = this
      that.laoding = true
      that.MaBottom = '加载中......'
      if (that.page === 1) {
        that.listT = []
      }
      that.scroll = false
      this.$axios.post(process.env.API_HOST + '/api/getGoodsList',
        {
          goodsName: this.goodsName,
          classifyOne: this.classifyOne,
          classifyTwo: this.classifyTwo,
          classifyThree: this.classifyThree,
          page: this.page,
          limit: this.limit,
          LoginType: 1,
          sourceType: this.iSsource
        }).then(
        function (res) {
          res = res.data
          that.laoding = false
          that.MaBottom = '下拉加载更多......'
          if (res.data.productList[0].vip_price === '***') {
            var storage = window.sessionStorage
            storage.setItem('GiftToken', '')
          }
          if (res.data.productList.length < that.limit) {
            that.MaBottom = '没有更多'
            that.scroll = false
          } else {
            that.scroll = true
          }
          if (that.page === 1) {
            that.listT = res.data.productList
          } else {
            that.listT = [...that.listT, ...res.data.productList]
          }
        }
      ).catch(error => console.log(error))
    },
  }
}
</script>
<style lang="stylus">
.title
  font-size px(32)
  color #333
  text-align center
.xian
  width px(44)
  height px(6)
  background rgba(0,0,0,.2)
  margin px(24) auto
</style>
<style lang="stylus" scoped>
.app
  height 100%
  overflow auto
  padding-bottom px(110)
.ngZ
  width 100%
.info
  font-size px(24)
  color #999
  margin 0 auto
  text-align center
  margin-top px(20)
  margin-bottom px(60)
  font-weight 400
.ma
  width px(220)
  margin 0 auto
  display block
  margin-top px(40)
</style>



// WEBPACK FOOTER //
// src/pages/gyl/gyl.vue